import { render, staticRenderFns } from "./Login.vue?vue&type=template&id=0d20fce6&scoped=true&"
import script from "./Login.vue?vue&type=script&async=true&lang=js&"
export * from "./Login.vue?vue&type=script&async=true&lang=js&"
import style0 from "./Login.vue?vue&type=style&index=0&id=0d20fce6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d20fce6",
  null
  
)

export default component.exports